// extracted by mini-css-extract-plugin
export var centerList = "_gd-6";
export var centerLoc = "_gd-a";
export var centerName = "_gd-9";
export var centerOptionBody = "_gd-8";
export var centerRow = "_gd-7";
export var centerStatus = "_gd-b";
export var empty = "_gd-5";
export var externalIcon = "_gd-c";
export var fieldHeader = "_gd-2";
export var fieldHelp = "_gd-4";
export var fieldLabel = "_gd-3";
export var panel = "_gd-0";
export var removeBtn = "_gd-d";
export var section = "_gd-1";